/**
 * The package name used for contextualizing reported logging and warnings.
 *
 * @type {string}
 */
export const PACKAGE_NAME = 'send_message_package';
